module.exports = __webpack_public_path__ + "images/marketing/2014-annual-report.jpg";